import {
  TRIAL_LIFECYCLE_CONFLICT_REASON,
  type TrialLifecycleConflict,
} from './trial-lifecycle.types';

export function hasTrialLifecycleConflict(
  conflict?: TrialLifecycleConflict | null,
): boolean {
  return Boolean(conflict?.reason);
}

export function getTrialLifecycleConflictMessage(
  conflict?: TrialLifecycleConflict | null,
): string {
  if (!conflict?.reason) {
    return '';
  }

  switch (conflict.reason) {
    case TRIAL_LIFECYCLE_CONFLICT_REASON.STALE_EXTERNAL_AFTER_PORTAL_UPDATE:
      return (
        conflict.details?.trim() ||
        'This trial was updated in Enrollio after the booking calendar sent an older change. Review the trial and mark it resolved when it looks correct.'
      );
    case TRIAL_LIFECYCLE_CONFLICT_REASON.DUPLICATE_OR_OUT_OF_ORDER_EXTERNAL:
      return (
        conflict.details?.trim() ||
        'The booking calendar sent a duplicate or out-of-order update. Review the trial and mark it resolved when it looks correct.'
      );
    default:
      return (
        conflict.details?.trim() ||
        'This trial needs review because Enrollio and the booking calendar disagree.'
      );
  }
}
